<div [appLdsRoller]="loading_next">
  <div class="row component-component-table" [ngClass]="{'table-min': link_only}"
    style="justify-content: space-between;">
    @if (componentDataSource) {
      <div>
        <utils-bar [search]="true"
          (searchValueSubmitted)="filter_string=$event;updateSearchFilter()"
          (searchCleared)="filter_string='';updateSearchFilter();">
        </utils-bar>
      </div>
    }

    <mat-paginator [pageSizeOptions]="page_size_options"
      style="justify-self: flex-end;">
    </mat-paginator>

  </div>
  <!--  @if (components?.length<1) { <div>No data</div> }-->
  @if (components && components.length > 0) {
    <table (matSortChange)="updateSort($event)"
      [dataSource]="componentDataSource" [matSortActive]="component_columns[1]"
      class="table inner-component-events-table" mat-table matSort>
      @for (col of component_columns; track col) {
        @if (col==='Unlink') {
          <ng-container matColumnDef="{{col}}">
            <th *matHeaderCellDef mat-header-cell [disabled]>
              <!-- {{col | upperfirst | removeUnderscore}} -->
            </th>
            <td *matCellDef="let component;" mat-cell
              [matTooltipDisabled]="!eventsService.event_state[component.id]"
              [matTooltip]="eventsService.event_state[component.id]? eventsService.event_state[component.id].message : ''"
              [ngClass]="eventsService.event_state[component.id]? eventsService.event_state[component.id].state: ''">
              <button mat-button (click)="openAuditModal($event, component)" class="table-button"
                [matTooltip]="'View relationship audit information'"
                matTooltipPosition="above">
                <i class="fas fa-info-circle"></i>
              </button>
              <button mat-button (click)="unlinkComponent(component)" class="unlink-component-btn table-button"
                [matTooltip]="'Remove this ' + selected_component_relationship_type?.attributes?.name + ' from ' + parent_component?.attributes.name"
                matTooltipPosition="above"
                [disabled]="!canUnlink(component.id)">
                <i class="fas fa-unlink"></i>
              </button>
            </td>
          </ng-container>
        }
        <!--Name-->
        @if (col==='name') {
          <ng-container matColumnDef="{{col}}">
            <th *matHeaderCellDef mat-header-cell mat-sort-header
                [style.width]="format_dict?.[col]?.width && format_dict[col].width !== 'auto' ? format_dict[col].width + 'px' : null">
              {{selected_cols_component_dict[col]?.title || col | upperfirst | removeUnderscore}}
              @if (tableUtils.editing && format_dict?.[col]?.allow_resize===true) {
                <div (mousedown)="tableUtils.startDrag($event, col, format_dict)"
                  class="resize-col">
                  <i class="fas fa-grip-vertical"></i>
                </div>
              }
            </th>
            <td *matCellDef="let component;" [matTooltip]="component.attributes.description" mat-cell
              [ngClass]="eventsService.event_state[component.id]? eventsService.event_state[component.id].state: ''"
              [ngStyle]="format_dict?.[col]?.style || null" class="attribute-field">
              <input (change)="saveComponent(component, col, $event)"
                [(ngModel)]="component.attributes.name"
                [disabled]="selected_cols_component_dict[col]?.disabled || link_only" style="padding-top:2px;">
            </td>
          </ng-container>
        }
        <!--Start, End-->
        @if (extra_cols && extra_cols.includes(col) && col !=='name') {
          <ng-container matColumnDef="{{col}}">
            <th *matHeaderCellDef mat-header-cell
                [style.width]="format_dict?.[col]?.width && format_dict[col].width !== 'auto' ? format_dict[col].width + 'px' : null"
              mat-sort-header>{{selected_cols_component_dict[col]?.title || col | upperfirst | removeUnderscore}}
              @if (tableUtils.editing && format_dict?.[col]?.allow_resize===true) {
                <div (mousedown)="tableUtils.startDrag($event, col, format_dict)"
                  class="resize-col">
                  <i class="fas fa-grip-vertical"></i>
                </div>
              }
            </th>
            <td *matCellDef="let component;" mat-cell style="text-align: left;"
              [ngClass]="eventsService.event_state[component.id]? eventsService.event_state[component.id].state: ''"
              [ngStyle]="format_dict?.[col]?.style || null">
              @if (col==='start_time') {
                <div class="row center">
                  <date-time-picker
                    (date_changed)="component.attributes.start_time = $event;saveComponent(component, col, $event)"
                    [disabled]="selected_cols_component_dict[col]?.disabled"
                    [input_date]="component.attributes.start_time">
                  </date-time-picker>
                </div>
              }
              @if (col==='end_time') {
                <div class="row center">
                  <date-time-picker
                    (date_changed)="component.attributes.end_time = $event;saveComponent(component, col, $event)"
                    [disabled]="selected_cols_component_dict[col]?.disabled"
                    [input_date]="component.attributes.end_time">
                  </date-time-picker>
                </div>
              }
            </td>
          </ng-container>
        }
        <!--Constant Properties-->
        @if (property_columns.includes(col) && !extra_cols.includes(col)) {
          <ng-container matColumnDef="{{col}}">
            <th *matHeaderCellDef mat-header-cell
                [style.width]="format_dict?.[col]?.width && format_dict[col].width !== 'auto' ? format_dict[col].width + 'px' : null"
              >{{selected_cols_component_dict[col].title || cp_dict[col]?.attributes.name | upperfirst | removeUnderscore}}
              @if (tableUtils.editing && format_dict?.[col]?.allow_resize===true) {
                <div (mousedown)="tableUtils.startDrag($event, col, format_dict)"
                  class="resize-col">
                  <i class="fas fa-grip-vertical"></i>
                </div>
              }
            </th>
            <td *matCellDef="let component" class="input-cell" mat-cell style="text-align: left;"
              [matTooltipDisabled]="!eventsService.event_state[component.id]"
              [matTooltip]="eventsService.event_state[component.id]? eventsService.event_state[component.id].message : ''"
              [ngClass]="eventsService.event_state[component.id]? eventsService.event_state[component.id].state: ''"
              [ngStyle]="format_dict?.[col]?.style || null">
              @if (component_constants?.[component.id]?.hasOwnProperty(col)) {
                <generic-constant-field [constant]="component_constants[component.id][col]"
                  [constant_property]="cp_dict[col]"
                  (constant_changed)="component_constants[component.id][col].value = $event;"
                  (change_complete)="saveConstant(component, col, $event)"
                  [disabled]="cp_dict[col]?.attributes.is_calculation || selected_cols_component_dict[col]?.disabled"
                  [formats]="format_dict?.[col]"
                  class="constant-field"
                ></generic-constant-field>
              }
            </td>
          </ng-container>
        }
      }
      <tr *matHeaderRowDef="component_columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let component; columns: component_columns;" mat-row tabindex="1"></tr>
    </table>
  }
</div>
@if (!loading_next && (!components || components?.length < 1)) {
  <div
    class="inner-component-events-table-status">{{event_status}}
  </div>
}
